<!--
 * @Date: 2024-11-19
-->
<template>
<div class="explain_tpl">
  <!-- <div v-if="isRound" class="rule_btn_round" @click="isShow=true" /> -->
  <div :class="{'rule_btn': !isRound}" @click="isShow=true"> {{ $tm('index2024.award.rule') }} </div>

  <!-- 助力任务说明 -->
  <van-popup 
    v-model:show="isShow"
    class="task-explain-wrap"
  >
    <div class="title">助力任务说明</div>
    <div class="body">
      <p>有奖助力是为了鼓励用户踊跃参与指数活动，对活动有贡献的用户奖励;</p>
      <p>奖励：活动期间助力值前20名用户，可获得2025年厨师历一本;</p>
      <p>参与要求：已获得奖项礼盒用户不可参与，票选获奖用户不可参与排名；平台其它注册用户都可参加助力活动。</p>
    </div>
    <div class="time">
      <span class="label">活动时间：</span>
      2025.01.01 - 2025.01.16 
    </div>
    <div class="iknow-btn" @click="isShow = false">我已了解</div>
  </van-popup>
  <!-- <van-popup
    v-model:show="isShow"
    get-container="#app"
    position="bottom"
    :style="{ height: '80vh' }"
  >
    <div class="popup_tpl">
      <div class="popup_title font_bold">{{ $tm(`index2024.rule.title`) }}
        <i class="bg_close" @click="isShow=false" />
      </div>
      <div v-if="type == 'home'" class="popup_content">
        <p class="mb_20" v-html="$tm(`index2024.rule.text`)" />
        <span v-html="$tm(`index2024.rule.text1`)" />
        <p class="title font_bold" v-html="$tm(`index2024.rule.title2`)" />
        <span v-html="$tm(`index2024.rule.text2`)" />
        <p class="mt_10">{{$tm(`index2024.rule.time`)}}</p>
      </div>
      <div v-else class="popup_content">
        <span v-html="$tm(`index2024.${type}.tip`)" />
        <template v-if="$tm(`index2024.rule.${type}`)">
          <p class="title font_bold" v-html="$tm(`index2024.rule.title2`)" />
          <span v-html="$tm(`index2024.rule.${type}`)" />
        </template>
      </div>

      <div v-if="type==='chef' || type==='boss'|| type==='restaurant'" class="popup_content vote_content">
        <p class="title font_bold" v-html="$tm(`index2024.vote.title`)" />
        <ul class="vote_list">
          <li v-for="(text,i) in $tm(`index2024.vote.${type}`)" :key="i">{{ text }}</li>
        </ul>
        <p class="mt_10" v-html="$tm(`index2024.vote.time1`)" />
        <p class="mt_10" v-html="$tm(`index2024.vote.time2`)" />

      </div>
    </div>
  </van-popup> -->
</div>
</template>

<script>
export default {
  name: 'Rule', // 入围规则
  props: {
    isRound: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: false
    }
  }
}
</script>

<style lang="scss" scoped>
@function r($px){  // 适配 375px宽
	@return $px*(1/37.5)*1rem;
}
.popup_content{
  padding: r(60) r(24) r(0);
}
.vote_content{padding: r(16) r(24) r(40) !important;}
.vote_list{list-style: disc; padding-left: r(16); line-height: r(21);}
</style>
